import * as React from 'react';
import styles from './LabeledValue.module.scss';

export interface LabeledValueProps {
	label: string;
	value: string | React.ReactNode;
}

export const LabeledValue: React.SFC<LabeledValueProps> = props => {
	const { label, value } = props;

	return (
		<>
			<div className={styles.label}>{label}</div>
			<div className={styles.info}>{value}</div>
		</>
	);
};

export default LabeledValue;
